import { imageField } from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

export const standardHeroFields = [
  {
    name: 'body',
    type: 'richText',
  },
  {
    name: 'ctas',
    type: 'list',
    subFields: [
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'link',
        type: 'string',
      },
    ],
  },
  {
    name: 'textColor',
    type: 'string',
    enum: ['light', 'dark'],
  },
  imageField('backgroundImage'),
  imageField('foregroundImage'),
] as const satisfies DeepReadonly<Input[]>;

const standardHeroConfig = {
  name: 'Standard Hero',
  inputs: standardHeroFields,
};

export type StandardHeroProps = GenerateBuilder<typeof standardHeroFields>;

export default standardHeroConfig;
